/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateTradingChallengeOptions,
  CreateTradingChallengeResponses,
} from '../types/CreateTradingChallenge'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Create a new trading challenge. Allowed for ADMIN and INTEGRATOR only.
 * @summary Create a trading challenge
 * {@link /v1/trading_challenges}
 */
export function createTradingChallenge<ThrowOnError extends boolean = true>(
  options: Options<CreateTradingChallengeOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateTradingChallengeResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/trading_challenges',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateTradingChallengeResponses, ThrowOnError>>,
  )
}
